import { render, staticRenderFns } from "./MainStatus.vue?vue&type=template&id=54ad8a9d&scoped=true"
import script from "./MainStatus.vue?vue&type=script&lang=js"
export * from "./MainStatus.vue?vue&type=script&lang=js"
import style0 from "./MainStatus.vue?vue&type=style&index=0&id=54ad8a9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ad8a9d",
  null
  
)

export default component.exports